import { useRef } from 'react';
import { useInView } from 'framer-motion';
import { formatNumber, getPathWithRef } from 'helpers/utils';
import { FadeText, FadeContainer } from 'components/CustomAnimations';
import OurImpactLine from 'components/LottieElements/OurImpactLine';
import { ButtonBrand } from 'components/ButtonBrand';
import { AnimatedCounter } from 'components/CustomAnimations/AnimatedCounter';

export const OurImpact = () => {
  const sectionRef = useRef(null);
  const isInView = useInView(sectionRef, { once: true, margin: '-100px' });

  return (
    <div className="our-impact-container" ref={sectionRef}>
      <div className="our-impact-title">
        <FadeText inViewTrigger className="eyebrow-text" text="Our impact" />
        <FadeText
          inViewTrigger
          progressive
          className="h2-dtm"
          text="Oath has a proven track record of transforming the most important elections at the federal, state, and local level."
        />
        <FadeText
          inViewTrigger
          delay={2}
          className="h4-text"
          text="We’ve directed hundreds of thousands of donations with the power to move Congress, remake the courts, and tip the scales toward progress."
        />
      </div>
      <div className="our-impact-items">
        <FadeContainer className="our-impact-item" animateNow={isInView} delay={2.2}>
          <OurImpactLine number={1} />
          <div className="our-impact-item-content">
            <FadeText
              className="panel-sans-dtm"
              text={<AnimatedCounter to={500} suffix="K+" start={isInView} delay={2.2} />}
            />
            <FadeText className="h4-text" text="Donations directed to date" />
          </div>
        </FadeContainer>

        <FadeContainer className="our-impact-item" animateNow={isInView} delay={2.5}>
          <OurImpactLine number={2} />
          <div className="our-impact-item-content">
            <FadeText
              className="panel-sans-dtm"
              text={<AnimatedCounter to={35} prefix="$" suffix="M+" start={isInView} delay={2.5} />}
            />
            <FadeText className="h4-text" text="Directed in 2024" />
          </div>
        </FadeContainer>

        <FadeContainer className="our-impact-item" animateNow={isInView} delay={3}>
          <OurImpactLine number={3} />
          <div className="our-impact-item-content">
            <FadeText
              className="panel-sans-dtm"
              text={<AnimatedCounter to={67} suffix="%" start={isInView} delay={3} />}
            />
            <FadeText className="h4-text" text="Of funds to races decided by <5%" />
          </div>
        </FadeContainer>

        <FadeContainer className="our-impact-item" animateNow={isInView} delay={3.5}>
          <OurImpactLine number={4} />
          <div className="our-impact-item-content">
            <FadeText
              className="panel-sans-dtm"
              text={
                <AnimatedCounter
                  to={1000}
                  suffix="+"
                  start={isInView}
                  delay={3.5}
                  formatFn={val => formatNumber(val)}
                />
              }
            />
            <FadeText className="h4-text" text="Candidates & organizations supported" />
          </div>
        </FadeContainer>
      </div>
      <FadeContainer className="our-impact-button" animateNow={isInView} delay={4}>
        <ButtonBrand href={getPathWithRef('/impact_report')} target="_blank">
          Check out our 2024 impact report
        </ButtonBrand>
      </FadeContainer>
    </div>
  );
};
